module.exports = __webpack_public_path__ + "img/空间使用.1e549191.png";